export async function postCV(data, token) {
    const url = `api/cv`;
    console.log("data ", data);
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to post cv: ${response.status}`);
    }
}

export async function editCV(id, data, token) {
    const url = `api/cv/${encodeURIComponent((id))}`;
    console.log("data ", data);
    const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to post cv: ${response.status}`);
    }
    return await response.json();
}

export async function scoreCV(id, data, token) {
    const url = `api/cv/score/${encodeURIComponent((id))}`;
    console.log("data ", data);
    const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to score CV with error code: ${response.status}`);
    }
    return await response.json();
}

export async function getAllStaffMembers(token) {
    const url = `api/cv`;
    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to get CV data: ${response.status}`);
    }
    return await response.json();
}

export async function getSkills(token) {
    const url = "api/cv/skills";
    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to get skill data: ${response.status}`);
    }
    return await response.json();
}

export async function getIdNumber(token) {
    const url = `api/cv/MyCV`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Failed to get CV data: ${response.status}`);
    }
    return await response.json();
}

export async function parseCV(file, sessionId) {
    let parseResponse;
    await getCsrfToken().then(async (thisResponse) => {
        const url = "api/public/cv/parse";

        const formData = new FormData();
        formData.append('uploaded_file', file);

        const response = await fetch(url, {
            method: "PUT",
            body: formData,
            headers: {
                'X-XSRF-TOKEN': thisResponse.token,
                'Session-Token': sessionId
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to parse CV: ${response.status}`);
        }
        parseResponse = await response.json();
        console.log(parseResponse)
    })
        .catch((error) => {
            console.log(error);
            throw new Error(`Failed to get csrf token`);
        })
    return parseResponse;
}

export async function findById(id, token) {
    const url = `api/cv/${encodeURIComponent((id))}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to get CV with ID ${id} : ${response.status}`);
    }
    return await response.json();
}

export async function getCvsByJobId(jobId) {
    const url = `api/public/cv-info/${encodeURIComponent(jobId)}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to get CVs with jobId');
    }
    return await response.json();
}

export async function getCsrfToken() {
    const url = "api/public/csrf";

    const response = await fetch(url, {
        method: "GET",
    });

    if (!response.ok) {
        throw new Error(`Failed to get csrf token: ${response.status}`);
    }

    return await response.json();
}

export async function postExternalCV(data, sessionId) {
    await getCsrfToken().then(async (thisResponse) => {
        const url = `api/public/cv/external`;
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': thisResponse?.token,
                'Session-Token': sessionId
            }
        });
        if (!response.ok) {
            throw new Error(`Failed to post cv: ${response.status}`);
        }
    })
        .catch((error) => {
            console.log(error);
            throw new Error(`Failed to get csrf token`);
        })
}

export async function getCvDocument(fileName, token) {
    const url = `api/public/retrieve-cv?fileName=${encodeURIComponent(fileName)}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + token,
        }
    });
    if (!response.ok) {
        console.error(`Failed to fetch CV: ${response.status} - ${response.statusText}`);
        const errorText = await response.text(); // Get the error message from the response
        console.error('Response text:', errorText);
        throw new Error(`Failed to fetch CV with status ${response.status}`);
    }
    return await response.blob();
}

export async function getDocumentFile(fileName) {
    const url = `api/public/retrieve-file?fileName=${encodeURIComponent(fileName)}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        console.error(`Failed to fetch Document: ${response.status} - ${response.statusText}`);
        const errorText = await response.text(); // Get the error message from the response
        console.error('Response text:', errorText);
        throw new Error(`Failed to fetch Document with status ${response.status}`);
    }
    return await response.blob();
}

export async function getJobById(id) {
    const url = `api/public/job/${encodeURIComponent((id))}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch job title`)
    }
    return await response.json();
}

export async function getCompanyLogoByJobHashCode(hashCode) {
    const url = `api/public/company-logo-hashCode?hashCode=${encodeURIComponent(hashCode)}`;

    const response = await fetch(url,{
        method: "GET",
        headers: {
            'Accept': 'application/json'
        }
    });
    if (response.ok) {
        return await response.json();
    } else if (response.status === 404) {
        return null;
    } else {
        throw new Error(`Failed to fetch company logo: ${response.status}`);
    }
}

export async function startApplicationFlow() {
    try {
        const csrfResponse = await getCsrfToken()
        const url = `api/public/applicationflow`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': csrfResponse.token
            }
        });
        if (!response.ok) {
            throw new Error(`Failed to start the CV process: ${response.status}`);
        }
        return await response.text();
    } catch(error) {
        console.error('Error in starting application flow:', error);
        throw error;
    }
}

export async function manualCreateCv(sessionId) {
    try {
        const csrfResponse = await getCsrfToken()
        const url = `api/public/applicationflow/uploadCV`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': csrfResponse.token,
                'Session-Token': sessionId
            }
        });
        if (!response.ok) {
            throw new Error(`Failed to manually step over the uploadCv task: ${response.status}`);
        }
    } catch(error) {
        console.error('Error in starting application flow:', error);
        throw error;
    }
}

export async function deleteCVById(candidateId, token){
    const url = `api/cv/${encodeURIComponent(candidateId)}`;
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to delete CV with candidate id: ', candidateId);
    }
}
